const getRoutes = () => {
    const rotas = [
        {
            path: '/',
            name: '',
            meta: {
                requiresAuth: false,
            },
            component: () => import('@/modules/higia-login/higia-alma-login.vue'),
            children: [
                {
                    path: 'login',
                    name: 'login',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () => import('@/modules/higia-login/higia-alma-login.vue'),
                },
                {
                    path: 'errHigia',
                    name: 'errHigia',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import('higia-lib-components/src/lib-components/modules/higia-erro/higia-erro.vue'),
                },
                {
                    path: 'errBrowser',
                    name: 'errBrowser',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import(
                            'higia-lib-components/src/lib-components/modules/higia-erro/components/higia-incompatible-browser-page.vue'
                        ),
                },
                {
                    path: 'errPageNotfound',
                    name: 'errPageNotfounds',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import(
                            'higia-lib-components/src/lib-components/modules/higia-erro/components/higia-page-not-found.vue'
                        ),
                },
                {
                    path: '*',
                    name: 'pageNotFound',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "cadastroPreCadastroMedico" */ 'higia-lib-components/src/lib-components/modules/higia-erro/components/higia-page-not-found.vue'
                        ),
                },
            ],
        },
    ]
    return rotas
}

export default {
    getRoutes,
}
